export default "__VITE_ASSET__Cpsc84So__"